import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /reminder-types/cancellation/reminders
 * @returns {AxiosPromise<any>}
 */
export const GET_CANCELLATION_REMINDERS = () => request.get('/reminder-types/cancellation/reminders')

/**
 * @description DELETE /reminders/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_REMINDER = id => request.delete(`/reminders/${id}`)
